import * as React from "react";
import { FunctionComponent } from "react";

interface TabProps {
	id: any;
	displayText: string;
	isSelected: boolean;
	onClickTab: (id: number) => void;
	clickable?: boolean;
	customClass?: string;
	customSelectedClass?: string;
	overrideClass?: string;
	icon?: React.ReactNode;
	rightIcon?: React.ReactNode;
}

const Tab: FunctionComponent<TabProps> = ({
	id,
	displayText,
	isSelected,
	onClickTab,
	clickable = true, // default to true if not provided
	customClass,
	customSelectedClass,
	overrideClass,
	icon,
	rightIcon
}) => {
	let className = "tab";

	if (customClass) {
		className += ` ${customClass}`;
	}

	if (isSelected) {
		className += customSelectedClass ? ` ${customSelectedClass}` : " tab-selected";
	}

	if (!clickable) {
		className += " tab-not-clickable";
	}

	return (
		<div
			className={className}
			onClick={() => {
				if (clickable) {
					onClickTab(id);
				}
			}}
			style={{ cursor: clickable ? "pointer" : "not-allowed", display: 'flex', flexDirection: 'row', alignItems: 'center' }}
		>
			{icon ? (
				<h4>
					{icon}
					{displayText}
				</h4>
			) : (
				<h4>{displayText}</h4>
			)}
			{rightIcon && <img src={rightIcon} style={{width: 15, height: 15, marginLeft: 5}}/>}
		</div>
	);
};

export default Tab;
